import React, { Fragment } from "react";
import { motion } from "framer-motion";
import useWindowWidth from "../../hooks/useWindowWidth";
import LazyLoadingImg from "../Components/LazyLoadingImg";

export default function HeroSection() {
  const width = useWindowWidth();
  const isMobile = width <= 600;

  // Animation variants
  const textVariants = {
    hidden: { opacity: 0, y: -50 },
    visible: { opacity: 1, y: 0 },
  };

  const imgVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <Fragment>
      <motion.div
        className="mt-3 mx-2"
        initial={isMobile ? "hidden" : false}
        animate={isMobile ? "visible" : false}
        variants={textVariants}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <div className="row bg-blue ps-md-5 mx-0 py-5">
          <div className="col-12 px-0 position-relative">
            <div className="px-md-5 ps-md-3 pt-md-5 pt-0 mt-md-5 mt-0">
              <h1 className="a2-hero-font-1">
                Custom CRM Development <br />
                for AddressTwo
              </h1>
              <div className="py-md-3 a2-hero-font-2 mt-md-3 pd-2x">
                From lead generation to customer retention, our cloud-based CRM
                <br />
                automates your daily tasks, provides real-time insights, and
                <br />
                helps you scale your sales—faster and smarter.
              </div>

              {width >= 768 && (
                <div
                  className="row pt-3 pb-3 a2-rating-justify"
                  style={{ color: "#fff" }}
                >
                  <div className="col-3">
                    <div className="a2-font-1">5M+</div>
                    <div className="a2-font-2">Daily Emails Delivered</div>
                  </div>
                  <div className="col-3" style={{ paddingLeft: "1.8rem" }}>
                    <div className="a2-font-1">100+</div>
                    <div className="a2-font-2">Monthly New Signups</div>
                  </div>
                </div>
              )}
            </div>
            {width >= 1094 && (
              <div className="a2-hero-image">
                <img
                  src="/images/a2-portfolio-hero-section.png"
                  alt="a2-portfolio-hero-section"
                  loading="eager"
                />
              </div>
            )}
          </div>
        </div>
      </motion.div>

      {isMobile && (
        <motion.div
          style={{ placeSelf: "center", marginTop: "-40px" }}
          initial="hidden"
          animate="visible"
          variants={imgVariants}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
        >
          <LazyLoadingImg
            src="/images/a2-portfolio-hero-section-mobile.png"
            alt="a2-portfolio-hero-section-mobile"
          />
        </motion.div>
      )}
    </Fragment>
  );
}
